import './more-info.scss';
import 'slick-carousel';
import 'magnific-popup';
import AOS from 'aos';

export default () => {
	$( '.js-more-info-slider' ).slick( {
		rows: 0,
		speed: 300,
		arrows: false,
		infinite: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		adaptiveHeight: true,
	} );

	$( '.js-popup-video' ).magnificPopup( {
		disableOn: 700,
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false,
		fixedContentPos: false,
	} );

	AOS.init( {
		duration: 800,
		once: true,
	} );
};
